import { config } from '../config';
import { useQuery } from 'react-query';

export const getObstacles = () => {
  const { status, data, error } = useQuery(['issues'], callGetObstaclesApi);
  return {
    statusGetObstacles: status,
    obstaclesFeatures: data,
    errorGetObstacles: error
  };
};

const callGetObstaclesApi = async () => {
  const url = `${config.url.OBSTACLES_URL}`;
  const credentials = btoa('someware:~2V2JajfKh9UXi2~r2Z7');
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Authorization': `Basic ${credentials}`
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error fetching issues ! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching issues', error.message, error);
    throw error;
  }
};